<mat-toolbar class="topbar">
  <!-- Nav items -->
  <ng-container *ngIf="isLoggedIn()">
    <ng-container *ngFor="let item of navItems">
      <a
        *ngIf="isNavItemVisible(item)"
        mat-button
        [routerLink]="item.route"
        routerLinkActive="active-nav-item"
        [routerLinkActiveOptions]="{ exact: item.exact }"
        class="nav-btn"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span class="nav-label">{{ item.label }}</span>
      </a>
    </ng-container>
  </ng-container>

  <!-- Spacer -->
  <span class="spacer"></span>

  <ng-container *ngIf="isLoggedIn()">
    <!-- Theme toggle -->
    <button
      mat-icon-button
      (click)="onToggleTheme()"
      [matTooltip]="themeService.isDark() ? 'Tema chiaro' : 'Tema scuro'"
      class="theme-toggle-btn"
    >
      <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <!-- User info -->
    <span class="user-name">{{ fullname }}</span>

    <!-- Logout -->
    <button
      mat-icon-button
      (click)="logout()"
      matTooltip="Logout"
      class="logout-btn"
    >
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </ng-container>
</mat-toolbar>
